const BLACK_CHANNEL_THRESHOLD = 34
const BLACK_ROW_RATIO = 0.86
const MIN_LETTERBOX_RATIO = 0.08
const MAX_SAMPLE_WIDTH = 160

const isBlackPixel = (data: Uint8ClampedArray, index: number): boolean =>
	data[index] <= BLACK_CHANNEL_THRESHOLD &&
	data[index + 1] <= BLACK_CHANNEL_THRESHOLD &&
	data[index + 2] <= BLACK_CHANNEL_THRESHOLD

const isBlackRow = (
	data: Uint8ClampedArray,
	width: number,
	row: number,
): boolean => {
	let blackPixels = 0
	const rowOffset = row * width * 4

	for (let x = 0; x < width; x += 1) {
		if (isBlackPixel(data, rowOffset + x * 4)) {
			blackPixels += 1
		}
	}

	return blackPixels / width >= BLACK_ROW_RATIO
}

export const getVisibleVideoAspectRatio = (
	video: HTMLVideoElement,
): number | null => {
	if (
		video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA ||
		!video.videoWidth ||
		!video.videoHeight
	) {
		return null
	}

	const sampleWidth = Math.min(MAX_SAMPLE_WIDTH, video.videoWidth)
	const sampleHeight = Math.max(
		1,
		Math.round((sampleWidth * video.videoHeight) / video.videoWidth),
	)

	const canvas = document.createElement('canvas')
	canvas.width = sampleWidth
	canvas.height = sampleHeight

	const context = canvas.getContext('2d', { willReadFrequently: true })
	if (!context) {
		return null
	}

	try {
		context.drawImage(video, 0, 0, sampleWidth, sampleHeight)
		const imageData = context.getImageData(0, 0, sampleWidth, sampleHeight).data

		let top = 0
		while (top < sampleHeight && isBlackRow(imageData, sampleWidth, top)) {
			top += 1
		}

		let bottom = sampleHeight - 1
		while (bottom > top && isBlackRow(imageData, sampleWidth, bottom)) {
			bottom -= 1
		}

		const letterboxHeight = top + (sampleHeight - 1 - bottom)
		if (letterboxHeight / sampleHeight < MIN_LETTERBOX_RATIO) {
			return null
		}

		const visibleHeight = bottom - top + 1
		if (visibleHeight <= 0) {
			return null
		}

		const visibleAspectRatio = sampleWidth / visibleHeight
		return visibleAspectRatio > 1 ? visibleAspectRatio : null
	} catch {
		return null
	}
}
